<template>
  <Modal
    name="REOPEN_QUOTE_MODAL"
    :title="$t('appointment.adminActions.quoteReopen.action')"
    actions
  >
    <template v-slot:body>
      <div>
        <v-alert type="warning">
          {{ $t('appointment.adminActions.quoteReopen.warningMessage') }}
        </v-alert>
      </div>
    </template>
    <template v-slot:actions>
       <v-btn
        @click="closeAllModals"
        :disabled="isLoading || isQuoteReopening"
        elevation="0"
        class="mr-5"
        large
        text
      >
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>

      <v-btn
        @click="reopenQuote"
        :loading="isLoading || isQuoteReopening"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('appointment.adminActions.quoteReopen.action') }}
      </v-btn>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/app/Modal'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'AdminAppointmentQuoteReopen',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters(['appointment', 'isLoading']),
  },
  methods: {
    ...mapActions(['reopenAppointmentQuote']),
    ...mapMutations(['closeAllModals']),

    reopenQuote() {
      this.isQuoteReopening = true

      const body = {
        appointment_id: this.appointment.id
      }

      this.reopenAppointmentQuote(body)
        .then(() => this.$parent?.refreshMap())
        .then(() => {
          if (this.$parent?.refreshMap) this.$parent?.refreshMap()
          if (this.$parent?.refreshAppointments) this.$parent?.refreshAppointments()
        })
        .finally(() => this.isQuoteReopening = false)
    },
  },

  data() {
    return {
      isQuoteReopening: false,
    }
  }
}
</script>
